(() => {
  const roots = document.querySelectorAll('[data-mm-product-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const variantsNode = root.querySelector('[data-mm-variants]');
    if (!variantsNode) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (e) { return; }

    const form = root.querySelector('.mm-pdp-form');
    const variantInput = root.querySelector('[data-mm-variant-id]');
    const price = root.querySelector('[data-mm-price]');
    const compare = root.querySelector('[data-mm-compare]');
    const addButton = root.querySelector('[data-mm-add]');
    const addLabel = root.querySelector('[data-mm-add-label]');
    const stickyPrice = root.querySelector('[data-mm-sticky-price]');
    const stickyAdd = root.querySelector('[data-mm-sticky-add]');
    const optionButtons = [...root.querySelectorAll('[data-mm-option-value]')];
    const mediaItems = [...root.querySelectorAll('[data-mm-media-id]')];
    const mediaThumbs = [...root.querySelectorAll('[data-mm-media-thumb]')];
    const qty = root.querySelector('[data-mm-qty]');
    const mediaStage = root.querySelector('[data-mm-media-stage]');

    const selectedOptions = () => {
      const positions = new Map();
      optionButtons.filter((button) => button.classList.contains('is-active')).forEach((button) => {
        positions.set(Number(button.dataset.mmOptionPosition), button.dataset.mmOptionValue);
      });
      return [...positions.keys()].sort((a, b) => a - b).map((key) => positions.get(key));
    };

    const exactVariant = () => {
      const selected = selectedOptions();
      if (!selected.length) return variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0];
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };

    const showMedia = (id) => {
      if (!id) return;
      const match = mediaItems.find((item) => String(item.dataset.mmMediaId) === String(id));
      if (!match) return;

      mediaItems.forEach((item) => {
        const active = item === match;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });
      mediaThumbs.forEach((thumb) => {
        const active = String(thumb.dataset.mmMediaThumb) === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && thumb.scrollIntoView) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    };

    const activeMediaIndex = () => mediaItems.findIndex((item) => !item.hidden);

    const stepMedia = (direction) => {
      if (mediaItems.length < 2) return;
      const current = Math.max(0, activeMediaIndex());
      const next = (current + direction + mediaItems.length) % mediaItems.length;
      showMedia(mediaItems[next].dataset.mmMediaId);
    };

    const updateVariant = () => {
      const variant = exactVariant();
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'UNAVAILABLE';
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'UNAVAILABLE'; }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      root.dataset.mmCurrentVariant = variant.id;
      if (price) price.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;

      if (compare) {
        if (variant.comparePrice) {
          compare.textContent = variant.comparePrice;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      if (variant.featuredMediaId) showMedia(variant.featuredMediaId);

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const position = button.dataset.mmOptionPosition;
        optionButtons.filter((candidate) => candidate.dataset.mmOptionPosition === position).forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateVariant();
      });
    });

    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mmMediaThumb));
    });


    if (mediaStage && mediaItems.length > 1) {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      mediaStage.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
      }, { passive: true });

      mediaStage.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        const horizontalSwipe = Math.abs(deltaX) >= 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
        if (!horizontalSwipe) return;

        stepMedia(deltaX < 0 ? 1 : -1);
      }, { passive: true });

      mediaStage.setAttribute('tabindex', '0');
      mediaStage.setAttribute('aria-label', 'Product image gallery. Swipe on touch screens or use left and right arrow keys.');
      mediaStage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          stepMedia(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          stepMedia(-1);
        }
      });
    }

    root.querySelector('[data-mm-qty-minus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
    });

    root.querySelector('[data-mm-qty-plus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) + 1);
    });

    root.querySelector('[data-mm-share]')?.addEventListener('click', async () => {
      const payload = { title: document.title, url: window.location.href };
      if (navigator.share) {
        try { await navigator.share(payload); } catch (e) {}
      } else if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(window.location.href);
          const label = root.querySelector('[data-mm-share] span');
          if (label) {
            const original = label.textContent;
            label.textContent = 'Copied';
            setTimeout(() => { label.textContent = original; }, 1400);
          }
        } catch (e) {}
      }
    });

    stickyAdd?.addEventListener('click', () => {
      if (!form || stickyAdd.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton || undefined);
      else addButton?.click();
    });

    updateVariant();
  });
})();
